import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import Manifesto from "@/components/site/Manifesto";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Consultation from "@/components/site/Consultation";
import Gallery from "@/components/site/Gallery";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";

export default function Home() {
  const [content, setContent] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
    api.get("/photos").then((r) => setPhotos(r.data)).catch(() => {});
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  return (
    <main className="bg-cream overflow-x-hidden">
      <Navbar />
      <Hero content={content} />
      <BrandMarquee />
      <Manifesto />
      <About content={content} />
      <Services />
      <Consultation />
      <Gallery photos={photos} />
      <ContactForm />
      <Footer />
    </main>
  );
}
